import { Link } from 'react-router';

export default function NotFound() {
    return (
        <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-white px-6 text-center">
            <img src="/logo.svg" alt="Podus" className="h-9 w-auto" />
            <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-primary">404</p>
            <h1 className="text-[28px] font-bold leading-tight text-secondary sm:text-[36px]">
                We couldn&rsquo;t find that page
            </h1>
            <p className="max-w-md text-[15px] leading-7 text-[#747474]">
                The link may be out of date. Head back to the ambassador home page and try again from there.
            </p>
            <Link
                to="/"
                className="mt-2 rounded-full bg-secondary px-10 py-3.5 text-[15px] font-semibold text-white transition-transform hover:scale-[1.02]"
            >
                Back to home
            </Link>
        </div>
    );
}
